const replaceAll = (str: string, find: string, replace: string): string => str.replace(new RegExp(find, 'g'), replace);

export default replaceAll;
